'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductCardDirective = undefined;

var _tpl = require('./tpl.html');

var _tpl2 = _interopRequireDefault(_tpl);

var _index = require('./index');

var _index2 = _interopRequireDefault(_index);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductCardDirective = function ProductCardDirective() {
  return {
    restrict: 'E',
    template: _tpl2.default,
    controller: _index2.default,
    controllerAs: '$ctrl',
    scope: {},
    bindToController: {
      product: '=',
      editProduct: '&',
      deleteProduct: '&',
      purchaseProduct: '&',
      editable: '=?',
      feis: '='
    }
  };
};

exports.ProductCardDirective = ProductCardDirective;


//////////////////
// WEBPACK FOOTER
// ./product-list/product-card/product-card.directive.js
// module id = 499
// module chunks = 0